"use client";
import { WEB_COLORS } from "@/lib/constants";
import { Box, Drawer, Typography, useMediaQuery } from "@mui/material";
import { useEffect } from "react";

const DrawerComponent = ({
  open,
  handleDrawer,
  children,
  anchor = "bottom",
  title = "",
  extraFunction,
  // backBtnClose = true,
  ...props
}) => {
  const isMobile = useMediaQuery("(max-width:700px)");

  useEffect(() => {
    const handlePopState = () => {
      if (open) {
        // Drawer is open → close it, prevent navigation
        handleDrawer && handleDrawer(false);
        // Re-push state to keep user on same page
        window.history.pushState(null, document.title, window.location.href);
      }
    };

    // When drawer opens, push a fake history entry so back button triggers popstate
    if (open) {
      window.history.pushState(null, document.title, window.location.href);
    }

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [open, handleDrawer]);

  return (
    <Drawer
      open={open}
      onClose={() => handleDrawer(false)}
      anchor={isMobile ? "bottom" : "right"}
      {...props}>
      <Box
        sx={{
          minWidth: 300,
          width: isMobile ? "100vw" : "70vw",
          height: isMobile ? "100vh" : "70vh",
          mx: "auto",
          p: 2,
        }}>
        {title && (
          <Typography
            variant="h6"
            gutterBottom
            color={WEB_COLORS.primary}
            fontWeight={700}>
            {title}
          </Typography>
        )}
        {children}
      </Box>
    </Drawer>
  );
};

export default DrawerComponent;
